import { ChevronLeft, ChevronRight } from "lucide-react";
import { competenciaAtual, nomeDoMes, somarMeses } from "@bookdental/schemas";

const botao =
  "flex h-9 w-9 items-center justify-center rounded-md text-zinc-600 hover:bg-zinc-100 disabled:opacity-40 dark:text-muted-foreground dark:hover:bg-muted";

/** ‹ outubro de 2026 › — o mês do financeiro inteiro. */
export function SeletorDeMes({ valor, onChange }: { valor: string; onChange: (competencia: string) => void }) {
  const atual = competenciaAtual();
  return (
    <div className="inline-flex items-center rounded-lg border border-zinc-200 bg-white shadow-sm dark:border-border dark:bg-card">
      <button type="button" aria-label="Mês anterior" onClick={() => onChange(somarMeses(valor, -1))} className={botao}>
        <ChevronLeft className="h-4 w-4" />
      </button>
      <span className="min-w-[150px] px-1 text-center text-sm font-semibold text-zinc-900 dark:text-foreground">
        {nomeDoMes(valor).replace(/^./, (c) => c.toUpperCase())}
      </span>
      <button type="button" aria-label="Próximo mês" onClick={() => onChange(somarMeses(valor, 1))} className={botao}>
        <ChevronRight className="h-4 w-4" />
      </button>
      {valor !== atual && (
        <button
          type="button"
          onClick={() => onChange(atual)}
          className="mr-1 rounded-md px-2 py-1 text-xs font-semibold text-brand-700 hover:bg-brand-50 dark:text-primary dark:hover:bg-primary/10"
        >
          Hoje
        </button>
      )}
    </div>
  );
}
